import { useEffect, useState } from "react"
import { createPortal } from "react-dom"
// @ts-ignore: librería copiada en src/vendor (sin tipos)
import qrcode from "../../../../vendor/qrcode-generator"

import aula from "../../../../services/v2/aula.service"
import { mensajeDeAula } from "../../../../utils/abrirAula"
import { ScheduleDTO } from "../../../../models/ScheduleDTO"

/*
	"Agregar Mi Celular Como Cámara" (aula virtual, Fase 2b): junto a "Abrir Aula". El servidor da un enlace de
	un solo uso (10 min); aquí se dibuja como código QR en el navegador y como enlace por si el maestro lo
	prefiere copiar. El celular entra al aula como "<Nombre> (Cámara 2)", sin audio y con la cámara lista.
	Mismas reglas que Abrir Aula: si no es la hora o no le toca, el motivo sale aquí.
*/
const dibujarQr = (url: string): string =>
{
	const qr = qrcode(0, "M")
	qr.addData(url)
	qr.make()
	return qr.createSvgTag({ cellSize: 4, margin: 0, scalable: true })
}

const tiempo = (seg: number): string => Math.floor(seg / 60) + ":" + String(seg % 60).padStart(2, "0")

const BotonCamaraCelular = ({horario, className} : {horario : ScheduleDTO, className? : string}) =>
{
	const [pidiendo, setPidiendo] = useState<boolean>(false)
	const [aviso, setAviso] = useState<string | null>(null)
	const [enlace, setEnlace] = useState<{url : string, venceMs : number} | null>(null)
	const [restante, setRestante] = useState<number>(0)
	const [copiado, setCopiado] = useState<boolean>(false)

	useEffect(() =>
	{
		if (!enlace) return
		const tic = () => setRestante(Math.max(0, Math.round((enlace.venceMs - Date.now()) / 1000)))
		tic()
		const id = window.setInterval(tic, 1000)
		return () => window.clearInterval(id)
	}, [enlace])

	const pedir = async () =>
	{
		setAviso(null)
		setCopiado(false)
		setPidiendo(true)
		try
		{
			const r = (await aula.cameraToken(horario.scheduleId)).data
			setEnlace({ url : r.url, venceMs : r.expiresAtMs })
		}
		catch (e) { setAviso(mensajeDeAula(e)) }
		finally { setPidiendo(false) }
	}

	const copiar = async () =>
	{
		if (!enlace) return
		try { await navigator.clipboard.writeText(enlace.url); setCopiado(true) } catch { /* sin portapapeles: el enlace queda a la vista */ }
	}

	const vencido = enlace !== null && restante <= 0

	return <>
		<button type="button" className={className || "waAccionFila"} disabled={pidiendo} onClick={(e) => { e.stopPropagation(); pedir() }}>
			Agregar Mi Celular Como Cámara
		</button>
		{aviso ? <span role="alert" style={{color : "var(--wa-oro, #A8730A)", fontSize : "14px", fontWeight : 600}}>{aviso}</span> : null}
		{enlace ? createPortal(
			<div
				role="dialog"
				aria-label="Celular Como Cámara"
				onClick={() => setEnlace(null)}
				style={{position : "fixed", inset : 0, zIndex : 2000, background : "rgba(43, 28, 22, .55)", display : "flex", alignItems : "center", justifyContent : "center", padding : "16px"}}
			>
				<div
					onClick={(e) => e.stopPropagation()}
					style={{background : "var(--wa-superficie, #fff)", color : "var(--wa-tinta, #2B1C16)", border : "1px solid var(--wa-filo, #EDE2DA)", borderRadius : "14px", padding : "20px", width : "min(340px, 100%)", maxHeight : "100%", overflow : "auto", display : "flex", flexDirection : "column", alignItems : "center", gap : "14px"}}
				>
					<div style={{display : "flex", alignItems : "center", justifyContent : "space-between", width : "100%"}}>
						<h5 style={{margin : 0, fontWeight : 800, color : "var(--wa-tinta, #2B1C16)"}}>Celular Como Cámara</h5>
						<button type="button" className="btn btn-sm" aria-label="Cerrar" style={{color : "var(--wa-tinta, #2B1C16)", fontSize : "22px", lineHeight : 1}} onClick={() => setEnlace(null)}>&times;</button>
					</div>
					<div
						aria-label="Código QR"
						style={{width : "min(220px, 55vw)", opacity : vencido ? 0.15 : 1, background : "#fff", padding : "10px", borderRadius : "8px"}}
						dangerouslySetInnerHTML={{__html : dibujarQr(enlace.url)}}
					/>
					<code style={{color : "var(--wa-apagado, #6B5F58)", maxWidth : "100%", overflow : "hidden", textOverflow : "ellipsis", whiteSpace : "nowrap", fontSize : "13px"}}>
						{enlace.url.replace(/^https?:\/\//, "")}
					</code>
					<div style={{display : "flex", gap : "8px", flexWrap : "wrap", justifyContent : "center", alignItems : "center"}}>
						{vencido
							? <button type="button" className="btn btn-primary" disabled={pidiendo} onClick={pedir}>Generar Nuevo</button>
							: <>
								<button type="button" className="btn btn-outline-primary" onClick={copiar}>{copiado ? "Copiado" : "Copiar Enlace"}</button>
								<span style={{fontWeight : 600, fontVariantNumeric : "tabular-nums"}}>Vence En {tiempo(restante)}</span>
							</>}
					</div>
				</div>
			</div>,
			document.body
		) : null}
	</>
}

export default BotonCamaraCelular
